import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  RequestTypes,
  permitTemplateKeys,
} from '@core/react-query/features/templates/permitTemplates/permitTemplate'
import { foldersKeys } from '@core/react-query/features/folders'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useDeletePermitTemplate = (
  options?: UseMutationOptions<
    Response,
    RequestErrorType,
    RequestTypes['deletePermitTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...permitTemplateKeys.deletePermitTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: permitTemplateKeys._def })
      queryClient.invalidateQueries({ queryKey: foldersKeys._def })
    },
    ...options,
  })
}
